import { OnboardingNotifications } from '../../../models/OnboardingNotifications';
import { GET_ONBOARDING_NOTIFICATIONS, UserActions, REDIRECT_TO_LOGIN, GET_USER } from './types';
import { Notifications } from '../../../models/Notifications';
import { AppState } from '../index';
import { DashboardLang } from '../../../constants/DashboardLang';
import { User } from '../../../models/User';

export interface IUserState {
    item: User | undefined;
    onboardingNotifications: OnboardingNotifications | undefined;
    isNotAuthenticated: boolean;
    companyName?: string;
}
export const INITIAL_STATE: IUserState = {
    item: undefined,
    onboardingNotifications: undefined,
    isNotAuthenticated: false,
    companyName: '',
};

export default function(state = INITIAL_STATE, action: UserActions) {
    switch (action.type) {
        case GET_USER:
            return { ...state, item: action.payload.user };

        case GET_ONBOARDING_NOTIFICATIONS:
            return { ...state, onboardingNotifications: action.payload.onboardingData };

        case REDIRECT_TO_LOGIN:
            return { ...state, isNotAuthenticated: true };

        default:
            return state;
    }
}
export const selectUserInfo = (state: AppState) => state.user.item;
export const selectNotificationsData = (state: AppState) => state.user.onboardingNotifications;
export const selectUserNotifications = (state: AppState): Notifications | null =>
    state.user?.item?.accountId ? state.user.item.notifications : null;
export const selectLanguageCode = (state: AppState): DashboardLang =>
    state.user?.item?.language ? state.user?.item?.language : DashboardLang.English;
